'use client';

import { AddToCartButton } from './AddToCartButton';
import { Alert, Box } from '@mui/material';
import { useTranslations } from 'next-intl';

interface Props {
  sku: string;
  accessorySku?: string;
  productTitle: string;
  imageUrl?: string;
  price: number;
}

export const AddToCartWithRequiredAccessories: React.FC<Props> = ({
  sku,
  accessorySku,
  ...props
}) => {
  const t = useTranslations();
  return (
    <Box sx={{ my: 2 }}>
      <AddToCartButton sku={sku} accessorySku={accessorySku} {...props} />
      {accessorySku && (
        <Alert severity="info" variant="outlined" sx={{ my: 2 }}>
          {t('Cart.required-accessory-will-be-added-to-cart', { sku: accessorySku })}
        </Alert>
      )}
    </Box>
  );
};
